'use strict';

import {reverseUrl} from 'utils/django';

import StateDiagram from 'incidents/utils/states';
import Q from 'incidents/utils/states/query';

var LovelandStateDiagram = new StateDiagram()
	.add('acknowledged', Q('acknowledged'))
	.add('complainant contacted', Q('contacts:call_completed', 'contacts:call_skipped'))
	.add('forming team', Q('geo:arrived'))
	.add('on-scene', Q.A('geo:arrived', Q('team:formation_call_initiated', 'team:formation_skipped')))
	.add('work completed', Q('geo:departed', 'geo:location_skipped'))
	.add('team done', Q('team:done'))
	.add('awaiting approval', Q('form_skipped'));


export default function(incident) {
	LovelandStateDiagram.updateIncident(incident);
	incident.phoneFromUrl =  reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});
	incident.DCCodes = [
		{code: '01', display: 'Leak Check - City'},
		{code: '02', display: 'Leak Check - Customers'},
		{code: '03', display: 'Main Break'},
		{code: '04', display: 'Meter Exchange'},
		{code: '05', display: 'PRV Exchange'},
		{code: '06', display: 'Locate'},
		{code: '07', display: 'Freeze Up - City'},
		{code: '08', display: 'Freeze Up - Customers'},
		{code: '09', display: 'Turn On Water'},
		{code: '10', display: 'Turn Off Water'},
		{code: '11', display: 'Pressure Test'},
		{code: '12', display: 'Sewer Plug - City'},
		{code: '13', display: 'Sewer Plug - Customers'},
		{code: '14', display: 'Talk to Customer'},
		{code: '15', display: 'Special Read'},
		{code: '16', display: 'Other - Water'},
		{code: '17', display: 'Other - Sewer'},
		{code: '18', display: 'Other - Other'},
		{code: '19', display: 'Sewer Odor'},
		{code: '20', display: 'Dirty Water'},
	];
}
